import Lottie from 'react-lottie';
import * as loading from './loading.json';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid meet',
  },
};

const Loading = () => {
  return (
    <>
      <section className="flex justify-center flex-col items-center gap-3">
        <Lottie options={defaultOptions} height={60} width={60} />  
      </section>
    </>
  );
};

export default Loading;
